import { useCallback } from "react";
import { postApiCcofPracticeIdPatientsSearch } from "@/lib/api-client/endpoints/ccof-patient/ccof-patient";
import { useTokenPagedInfiniteQuery } from "@/lib/query/useTokenPagedInfiniteQuery";
import { useRequestWrapper } from "@/lib/request/useRequestWrapper";
import { CcofPatientSearchResult } from "lib/api-types/schemas";

async function fetchPatientPage(
  practiceId: string,
  query: string,
  nextToken?: string,
) {
  const res = await postApiCcofPracticeIdPatientsSearch(practiceId, {
    filter: { query },
    pageSize: 20,
    nextToken,
  });

  return {
    items: res.data.items ?? [],
    nextToken: res.data.nextToken,
  };
}

export const patientSearchQueryKey = (practiceId: string, query: string) =>
  ["patients", "search", practiceId, query] as const;

export function usePatientSearch(practiceId: string, query: string) {
  const [fetchPage] = useRequestWrapper(
    useCallback(
      (nextToken?: string) => fetchPatientPage(practiceId, query, nextToken),
      [practiceId, query],
    ),
  );

  return useTokenPagedInfiniteQuery<CcofPatientSearchResult>({
    queryKey: patientSearchQueryKey(practiceId, query),
    fetchPage,
    enabled: query.length > 0,
  });
}
